import { Flex } from '@cad-arc';
import React from 'react';

interface FrQueueRowWrapperProps {
    leftChildren: React.ReactElement;
    rightChildren: React.ReactElement;
    onClickRightChildrenAction?: () => void;
    onClickLeftChildrenAction?: () => void;
    isFirstRow?: boolean;
}

export const FrQueueRowWrapper = ({
    leftChildren,
    rightChildren,
    onClickRightChildrenAction,
    onClickLeftChildrenAction,
    isFirstRow,
}: FrQueueRowWrapperProps) => {
    return (
        <Flex w="100%" height="100%" pt={isFirstRow ? undefined : '8px'} px="8px">
            <Flex
                borderRadius="6px"
                width="100%"
                height="100%"
                border="1px solid var(--arc-colors-border-default)"
                bgColor="var(--arc-colors-surface-accent)"
            >
                <Flex
                    flexBasis="40%"
                    columnGap="8px"
                    padding="2px"
                    height="100%"
                    justifyContent="space-between"
                    alignItems="stretch"
                    onClick={onClickLeftChildrenAction}
                    minW="0"
                    {...(onClickLeftChildrenAction
                        ? {
                              _hover: {
                                  cursor: 'pointer',
                                  backgroundColor: 'var(--arc-colors-interactive-hover)',
                              },
                              _active: {
                                  backgroundColor: 'var(--arc-colors-interactive-active)',
                              },
                          }
                        : {})}
                >
                    <Flex flexDirection="row" columnGap="8px" alignItems="stretch" w="100%">
                        {leftChildren}
                    </Flex>
                </Flex>
                <Flex
                    columnGap="8px"
                    paddingX="16px"
                    paddingY="2px"
                    flexBasis="60%"
                    justifyContent="space-between"
                    alignItems="center"
                    borderLeft="1px solid var(--arc-colors-border-default)"
                    onClick={onClickRightChildrenAction}
                    data-testid="fr-queue-row-right-block"
                    minW="0"
                    {...(onClickRightChildrenAction
                        ? {
                              _hover: {
                                  cursor: 'pointer',
                                  backgroundColor: 'var(--arc-colors-interactive-hover)',
                              },
                              _active: {
                                  backgroundColor: 'var(--arc-colors-interactive-active)',
                              },
                          }
                        : {})}
                >
                    {rightChildren}
                </Flex>
            </Flex>
        </Flex>
    );
};
